import axios from 'axios';
import env from '../config';

/**
 * Axios client for cookie-based token refresh only.
 */
const refreshTokenClient = axios.create({
  baseURL: env.apiBaseUrlRambla,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 20000,
  withCredentials: true,
});

export default refreshTokenClient;
